import { QueryDispatcher } from 'Util/Request';
import PromotionQuery from 'Query/Promotion.query';
import { showNotification } from 'Store/Notification/Notification.action';
import { requestPromotion } from 'Store/Promotion/Promotion.action';

export class PromotionDispatcher extends QueryDispatcher {
    onSuccess(data, dispatch) {
        dispatch(requestPromotion(data.promotions));
    }

    onError(error, dispatch) {
        dispatch(showNotification('error', 'Error fetching Promotions!', error));
    }

    prepareRequest(options) {
        return [
            PromotionQuery.getQuery(options)
        ];
    }
}

export default new PromotionDispatcher();
